import { Button, Text } from "components";
import { useTranslation } from "react-i18next";

import globalRequest from "../../../../utils/global/globalRequest";
import { useDispatch, useSelector } from "react-redux";
import { changeLoader } from "../../../../redux/reducers/loader";
import * as API from "../../../../utils/helper/Enum";
import { setSnackbar } from "../../../../redux/reducers/snackbar";
import * as CUSTOM from "../../../../utils/helper/custom";
import { useEffect, useState } from "react";
import {
  getGiftOrderData,
  updateGiftOrderData,
} from "../../../../redux/reducers/giftOrderData";
import { useAppFont } from "utils/helper/useAppFont";
let cdate = new Date();
let defaultSloat = {
  day: "",
  slots: [],
};

const DAY_NAMES = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
const MONTH_NAMES = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December",
];

// Get 7 days starting from a given date
const getWeekDays = (startDate) => {
  const days = [];
  for (let i = 0; i < 7; i++) {
    const d = new Date(startDate);
    d.setDate(d.getDate() + i);
    days.push(d);
  }
  return days;
};

// Get the Sunday of the week for a given date
const getWeekStart = (date) => {
  const d = new Date(date);
  const day = d.getDay();
  d.setDate(d.getDate() - day);
  return d;
};

const StepsDeliveryDateTime = ({ orderDetails }) => {
  const { t } = useTranslation();
  let orderData = useSelector(getGiftOrderData);
  let dispatch = useDispatch();
  const [slots, setSlots] = useState(defaultSloat);
  const [weekStart, setWeekStart] = useState(null);
  const [minDate, setMinDate] = useState(null);
  const [inputData, setInputData] = useState({
    date: "",
    initialDate: "",
    slotId: 0,
  });
  const { interClass, headingClass, interFamily, headingFamily} = useAppFont();

  /**
   * get time sloat
   */
  const getTimeSloats = async () => {
    cdate = inputData?.date ? inputData?.date : cdate;
    let date = CUSTOM.changeDateFormat(cdate, "yyyy-MM-dd");
    let day = CUSTOM.getDayOfWeek(date);
    let inpData = {
      lat: orderData?.addressData?.lattitude,
      long: orderData?.addressData?.longitude,
      day: day,
      date: date,
      user_id: orderData?.orderDetails?.userId,
      order_type: orderDetails?.orderType,
      order_id: orderDetails?.id,
    };
    try {
      dispatch(changeLoader(true));
      let response = await globalRequest(
        `${API.GIFTORDER.GET_TIME_SLOATS}`,
        "get",
        {},
        { params: inpData },
        true
      );
      response = response?.data;
      dispatch(changeLoader(false));
      if (response?.status == "SUCCESS") {
        setSlots(response?.data);
      } else {
        setSlots(defaultSloat);
      }
    } catch (e) {
      setSlots(defaultSloat);
    }
  };

  /**
   * submit form details
   */
  const submitForm = async () => {
    //SUBMIT_GIFT_DETAILS
    if (inputData?.slotId == 0) {
      return;
    }
    try {
      let inputFormData = {
        order_id: orderData?.orderDetails?.id,
        mobile_number: orderData?.mobile_no,
        address_details: {
          mobileNo: orderData?.mobile_no,
          streetNumber: orderData?.addressData?.streetNumber,
          buildingNumber: orderData?.addressData?.buildingNumber,
          floorApartment: orderData?.addressData?.floorApartment,
          address: orderData?.addressData?.address,
          lattitude: orderData?.addressData?.lattitude,
          longitude: orderData?.addressData?.longitude,
        },
        delivery_date: CUSTOM.changeDateFormat(inputData?.date, "yyyy-MM-dd"),
        time_slot_id: inputData?.slotId,
        branch_id: inputData?.branch_id,
      };
      dispatch(changeLoader(true));
      let response = await globalRequest(
        `${API.GIFTORDER.SUBMIT_GIFT_DETAILS}`,
        "post",
        inputFormData,
        {},
        true
      );
      response = response?.data;
      dispatch(changeLoader(false));
      if (response?.status == "SUCCESS") {
        inputFormData.pageStep = 4;
        inputFormData.timeLabel = inputData?.timeLabel;
        dispatch(updateGiftOrderData({ ...orderData, ...inputFormData }));
      } else {
        dispatch(
          setSnackbar({
            snackbarOpen: true,
            snackbarMessage: response?.message,
            snackbarState: "error",
          })
        );
      }
    } catch (e) {
      dispatch(
        setSnackbar({
          snackbarOpen: true,
          snackbarMessage: e?.message,
          snackbarState: "error",
        })
      );
    }
  };

  /**
   * get Current Time from server
   */
  const getCurrentTime = async () => {
    let newdate = CUSTOM.convertDateString(new Date(), "yyyy-MM-dd");
    try {
      let response = await globalRequest(
        API?.CART?.GET_CURRENT_DATE,
        "get",
        {},
        {}
      );
      response = response?.data;
      if (response.status == "SUCCESS") {
        newdate = CUSTOM.convertDateString(response?.data, "yyyy-MM-dd");
      }
    } catch (e) {
      console.log(e?.message);
    }
    const parsedDate = new Date(newdate);
    setMinDate(parsedDate);
    setWeekStart(getWeekStart(parsedDate));
    setInputData((prev) => ({
      ...prev,
      date: parsedDate,
      initialDate: parsedDate,
    }));
  };

  /**
   * sloat reset when address change
   */
  useEffect(() => {
    if (orderData?.addressData?.lattitude) {
      getCurrentTime();
      //  setInputData({ ...inputData, date: cdate });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderData?.addressData?.lattitude]);

  /**
   * Get sloats when change date and time
   */
  useEffect(() => {
    if (inputData?.date) {
      setInputData({ ...inputData, slotId: 0 });
      getTimeSloats();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputData?.date]);

  const goToPrevWeek = () => {
    const newStart = new Date(weekStart);
    newStart.setDate(newStart.getDate() - 7);
    // Don't go before current week
    if (minDate && newStart < getWeekStart(minDate)) return;
    setWeekStart(newStart);
  };

  const goToNextWeek = () => {
    const newStart = new Date(weekStart);
    newStart.setDate(newStart.getDate() + 7);
    setWeekStart(newStart);
  };

  const weekDays = weekStart ? getWeekDays(weekStart) : [];
  const isPrevDisabled = weekStart && minDate && weekStart <= getWeekStart(minDate);

  const getWeekLabel = () => {
    if (!weekDays.length) return "";
    const mid = weekDays[3];
    return `${MONTH_NAMES[mid.getMonth()]} ${mid.getFullYear()}`;
  };

  const isSameDay = (a, b) => {
    if (!a || !b) return false;
    const da = new Date(a);
    const db = new Date(b);
    return (
      da.getDate() === db.getDate() &&
      da.getMonth() === db.getMonth() &&
      da.getFullYear() === db.getFullYear()
    );
  };

  const isPastDay = (day) => {
    if (!minDate) return false;
    const d = new Date(day);
    d.setHours(0, 0, 0, 0);
    const m = new Date(minDate);
    m.setHours(0, 0, 0, 0);
    return d < m;
  };

  // Commented out - old DatepickerInput version:
  // <DatepickerInput required={true} disablePast={true} format={"DD/MM/YYYY"} label={t("deliveryDate")}
  //   min={inputData?.initialDate} value={inputData?.date}
  //   onChange={(e) => { setInputData({ ...inputData, date: e, slotId: 0 }); }} />

  return (
    <div className="relative flex flex-col w-full">

      {/* ── Header row: title + estimated prep time badge ── */}
      <div className="flex flex-row xs:flex-col xs:items-start items-start justify-between w-full mb-6 gap-3">
        <div className="flex flex-col gap-1">
          <Text
            className="text-[24px] leading-[32px]"
            style={{
              color: "var(--Blacks-900, #1A1A1A)",
              fontFamily: headingFamily,
              fontStyle: "normal",
              fontWeight: "500",
            }}
          >
            {t("deliveryDateAndTime")}
          </Text>
          {/* <Text className="text-gray-500 text-sm font-nunitoregular">
            {t("forYourItemsChooseTheDeliveryDateAndTime")}
          </Text> */}
        </div>

        {/* Estimated prep time badge — matches image: pink bg, clock icon */}
        {slots?.estimatedPrepTime && (
          <div className="flex flex-row items-center gap-1.5 bg-pink-50 border border-pink-200 rounded-full px-3 py-1.5 flex-shrink-0">
            {/* Clock icon */}
            <svg className="h-4 w-4 text-pink-800 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <circle cx="12" cy="12" r="10" strokeWidth="2" />
              <path strokeLinecap="round" d="M12 6v6l4 2" strokeWidth="2" />
            </svg>
            <span className="text-pink-800 text-xs font-nunitomedium whitespace-nowrap">
              Estimated Prep Time {slots?.estimatedPrepTime}
            </span>
          </div>
        )}
      </div>

      {orderData?.pageStep == 3 && (
        <div className="flex flex-col items-start justify-start w-full gap-6">

          {/* ── Week Calendar ── */}
          <div className="w-full">

            {/* Month navigation row */}
            <div className="flex flex-row items-center justify-between px-1 py-3 mb-3">
              {/* Prev arrow */}
              <button
                onClick={goToPrevWeek}
                disabled={isPrevDisabled}
                className={`flex items-center justify-center w-7 h-7 rounded-full transition-colors
                  ${isPrevDisabled
                    ? "text-gray-200 cursor-not-allowed"
                    : "text-gray-500 hover:bg-gray-100 cursor-pointer"
                  }`}
              >
                <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 19l-7-7 7-7" />
                </svg>
              </button>

              {/* Month + Year */}
              <span
                className="text-center"
                style={{
                  color: "var(--Blacks-900, #1A1A1A)",
                  fontFamily: interFamily,
                  fontSize: "20px",
                  fontStyle: "normal",
                  fontWeight: "500",
                  lineHeight: "28px",
                }}
              >
                {getWeekLabel()}
              </span>

              {/* Next arrow */}
              <button
                onClick={goToNextWeek}
                className="flex items-center justify-center w-7 h-7 rounded-full text-gray-500 hover:bg-gray-100 transition-colors cursor-pointer"
              >
                <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                </svg>
              </button>
            </div>

            {/* Day cards — each day is a separate card with gap */}
            <div className="grid grid-cols-7 gap-1.5 sm:gap-1">
              {weekDays.map((day, index) => {
                const isSelected = isSameDay(day, inputData?.date);
                const isPast = isPastDay(day);

                return (
                  <button
                    key={index}
                    type="button"
                    disabled={isPast}
                    onClick={() => {
                      if (!isPast) {
                        setInputData({ ...inputData, date: day, slotId: 0 });
                        setWeekStart(getWeekStart(day));
                      }
                    }}
                    className={`
                      flex flex-col items-center justify-center py-4 px-1
                      rounded-xl border
                      transition-all duration-150
                      ${isPast ? "cursor-not-allowed opacity-40" : "cursor-pointer"}
                      ${isSelected
                        ? "bg-[#771237] border-[#771237] shadow-sm"
                        : isPast
                        ? "bg-white-A700 border-gray-100"
                        : "bg-white-A700 border-gray-200 hover:border-pink-300 hover:bg-pink-50"
                      }
                    `}
                  >
                    {/* Full day name */}
                    <span
                    className={`text-center mb-1.5 ${
                      isSelected ? "text-[white]" : "text-gray-400"
                    }`}
                    style={{
                      fontFamily: interFamily,
                      fontSize: "18px",
                      fontStyle: "normal",
                      fontWeight: "400",
                      lineHeight: "24px",
                    }}
                  >
                    {DAY_NAMES[day.getDay()]}
                  </span>

                    {/* Date number */}
                    <span
                      className={`text-center ${
                        isSelected
                          ? "text-[white]"
                          : isPast
                          ? "text-gray-300"
                          : "text-gray-500"
                      }`}
                      style={{
                        fontFamily: interFamily,
                        fontSize: "18px",
                        fontStyle: "normal",
                        fontWeight: "400",
                        lineHeight: "24px",
                      }}
                    >
                      {day.getDate()}
                    </span>
                  </button>
                );
              })}
            </div>
          </div>

          {/* ── Time Slots ── */}
          <div className="w-full flex flex-col gap-3">
            <Text className={`text-base ${interClass} text-black-900`}>
              {slots?.slots?.length > 0 ? t("selectTimeSlot") || "Select Time Slot" : t("noSloatFound")}
            </Text>

            {slots?.slots?.length > 0 && (
              <div className="flex flex-row flex-wrap gap-3 w-full">
                {slots.slots.map((item, index) => {
                  const label = CUSTOM.formatTimeRange(item?.openTime, item?.closeTime);
                  const isSelected = inputData?.slotId === item?.id;
                  return (
                    <button
                      key={index}
                      type="button"
                      onClick={() => {
                        setInputData({
                          ...inputData,
                          branch_id: item?.branchId,
                          slotId: item?.id,
                          timeLabel: label,
                        });
                      }}
                      className={`
                        px-5 py-2.5 rounded-xl text-sm ${interClass}
                        border transition-all duration-150
                        ${isSelected
                          ? "bg-[#771237] border-[#771237] text-white-A700 shadow-sm"
                          : "bg-white-A700 border-gray-200 text-black-900 hover:border-pink-300 hover:bg-pink-50"
                        }
                      `}
                    >
                      {label}
                      {/* Discount badge */}
                      {item?.discount > 0 && (
                        <span
                          className={`ml-2 text-xs px-1.5 py-0.5 rounded-md
                            ${isSelected ? "bg-pink-700 text-white-A700" : "bg-green-100 text-green-700"}`}
                        >
                          -{item.discount}%
                        </span>
                      )}
                    </button>
                  );
                })}
              </div>
            )}
          </div>

          {/* ── Confirm Button — full width, pill shape, dark maroon ── */}
          <div className="w-full mt-1">
            <button
              type="button"
              disabled={inputData?.slotId == 0}
              onClick={submitForm}
              className={`
                w-full py-4 rounded-full
                transition-all duration-200
                ${inputData?.slotId == 0
                  ? "bg-gray-300 cursor-not-allowed"
                  : "bg-[#771237] hover:bg-[#771237] shadow-md hover:shadow-lg"
                }
              `}
              style={{
                color: "var(--Blacks-White, #FFF)",
                textAlign: "center",
                fontFamily: headingFamily,
                fontSize: "16px",
                fontStyle: "normal",
                fontWeight: "500",
                lineHeight: "24px",
              }}
            >
              {t("confirm")}
            </button>
          </div>

        </div>
      )}
    </div>
  );
};

export default StepsDeliveryDateTime;